const IGNORED_SINGLE_LETTER_SYMBOLS = new Set(["e", "E", "i", "I"]);

export const extractDifferentialVariable = (value) => {
  const text = String(value || "");
  const patterns = [
    /\\mathrm\{d\}\s*([a-zA-Z])/g,
    /\\,?d\s*([a-zA-Z])/g,
    /\bd\s*([a-zA-Z])\b/g,
  ];
  let match = null;
  let last = null;
  patterns.forEach((pattern) => {
    while ((match = pattern.exec(text)) !== null) {
      last = match[1];
    }
  });
  return last;
};

export const listSingleLetterVariables = (value) => {
  const text = String(value || "")
    .replace(/\\[a-zA-Z]+/g, " ")
    .replace(/\\mathrm\{d\}\s*[a-zA-Z]/g, " ")
    .replace(/\bd\s*[a-zA-Z]\b/g, " ");
  const matches = text.match(/[a-zA-Z]/g) || [];
  const filtered = matches.filter((letter) => !IGNORED_SINGLE_LETTER_SYMBOLS.has(letter));
  return new Set(filtered);
};

export const replaceLatexVariable = (value, fromVar, toVar) => {
  if (!value || !fromVar || !toVar || fromVar === toVar) return value;
  const pattern = new RegExp(`(^|[^\\\\a-zA-Z])${fromVar}(?=[^a-zA-Z]|$)`, "g");
  return String(value).replace(pattern, (match, prefix) => `${prefix}${toVar}`);
};

export const replacePlainTextVariable = (value, fromVar, toVar) => {
  if (!value || !fromVar || !toVar || fromVar === toVar) return value;
  const pattern = new RegExp(`(^|[^a-zA-Z])${fromVar}(?=[^a-zA-Z]|$)`, "g");
  return String(value).replace(pattern, (match, prefix) => `${prefix}${toVar}`);
};

export const suggestVariableFix = (latex, statement = "") => {
  const diffVar = extractDifferentialVariable(latex || statement);
  if (!diffVar) return null;
  const vars = Array.from(listSingleLetterVariables(latex || statement));
  if (!vars.length) return null;
  if (vars.includes(diffVar)) return null;
  if (vars.length !== 1) return null;
  return { fromVar: vars[0], toVar: diffVar };
};
